import {createSelector} from 'reselect';

import {AppParametricSelector} from '../../../../../helpers/reselectHelpers';
import {getPanels} from '../../../panelsSelectors';
import {panelIsCrmPreviewPanel} from '../../../panelsState';
import {CrmPreviewPanelId} from '../../../panelStateBase';
import {CrmPreviewPanelState} from './crmPreviewState';

/*
 * Selectors.
 */

export interface CrmPreviewPanelProps {
  panelId: CrmPreviewPanelId;
}

export type CrmPreviewPanelIdSelector<P> = AppParametricSelector<P, CrmPreviewPanelId>;

function getCrmPreviewPanelId(_state: unknown, props: CrmPreviewPanelProps) {
  return props.panelId;
}

export type CrmPreviewPanelSelector<P> = AppParametricSelector<P, CrmPreviewPanelState>;

export function makeGetCrmPreviewPanel(): CrmPreviewPanelSelector<CrmPreviewPanelProps>;
export function makeGetCrmPreviewPanel<P>(
  getPanelId: CrmPreviewPanelIdSelector<P>,
): CrmPreviewPanelSelector<P>;
export function makeGetCrmPreviewPanel(getPanelId: CrmPreviewPanelIdSelector<any> = getCrmPreviewPanelId) {
  return createSelector([getPanels, getPanelId], (panels, panelId) => {
    const panel = panels[panelId];

    if (!panel || !panelIsCrmPreviewPanel(panel)) {
      throw new Error('Contact card panel not found.');
    }

    return panel;
  });
}
